import React from 'react'
import { render } from 'react-dom'

import TimezoneModal from '../Modal/TimezoneModal'
import { ExternalModalAdapter } from '../../Common/Components/Modal/ExternalModalAdapter'
import { $window } from '../../../NonReact/common/AkixiWindow'

/**
 * Adapter to create the Timezone modal.
 */
export default class TimezoneAdapter extends ExternalModalAdapter {
    constructor() {
        super()

        $window.disableHotKeys = true

        render(<TimezoneModal />, this.modalDiv)
    }

    public static newInstance(): TimezoneAdapter {
        return new TimezoneAdapter()
    }
}
